let isEnabled: any;
function checkHideHeaderEnabled() {
    if (typeof isEnabled !== 'undefined') {
        return isEnabled;
    }

    try {
        const isFeatureEnabled =
            window.dazn.features.isEnabledAnonymous('f_ar_hide_header_unified_lp');
        isEnabled = isFeatureEnabled;
        return isFeatureEnabled;
    } catch (e) {
        return false;
    }
}



export {
    checkHideHeaderEnabled,
};
